// extracted by mini-css-extract-plugin
export default {"navGroup":"NavGroup_navGroup__Lt0VI","disabled":"NavGroup_disabled__1TNO+","groupName":"NavGroup_groupName__hpiue","subMenu":"NavGroup_subMenu__7gD1z"};